import React, { useEffect, useState } from 'react'
import Typography from '@/v2/components/common/Typography'
import Modal from '@/v2/components/common/Modal'
import SelectField from '@/v2/components/common/SelectField'
import Wrapper from '@/v2/components/common/Wrapper'
import {
  useConsentForms,
  useCreateConsentForm,
} from '@/v2/hooks/documents/useConsentForm'
import { useSnackbarContext } from '@/v2/contexts/SnackbarContext'

// Titles are stored uppercase. The document cards lowercase them and apply
// `capitalize`; a native <option> cannot be styled that way, so do it here.
const titleCase = title =>
  (title || '').toLowerCase().replace(/\b\w/g, letter => letter.toUpperCase())

const ConsentFormConfirmation = ({ isOpen, patientId, onClose }) => {
  // The container that opened this modal already cached the clinic's list.
  const { consentForms } = useConsentForms()
  const { createConsentForm } = useCreateConsentForm(patientId)
  const { onOpenSnackbar } = useSnackbarContext()
  const [consentFormId, setConsentFormId] = useState(null)

  // Seed with the first form once the list lands: it is the oldest, so the
  // whitening form keeps going out by default exactly as before.
  useEffect(() => {
    if (consentFormId === null && consentForms?.length > 0) {
      setConsentFormId(consentForms[0].id)
    }
  }, [consentForms, consentFormId])

  const handleConfirm = async () => {
    if (consentFormId === null) return

    try {
      const { error } = await createConsentForm(consentFormId)

      if (!error) {
        onOpenSnackbar('Consent form sent', 'success')
      }
      onClose()
    } catch (error) {
      onOpenSnackbar('Something went wrong.', 'error')
    }
  }

  return (
    <Modal
      fullWidth
      isOpen={isOpen}
      title={'Consent Form Confirmation'}
      confirmLabel="Confirm"
      showClose={true}
      submitDisabled={consentFormId === null}
      onConfirm={handleConfirm}
      onClose={onClose}
      maxWidth="xs"
    >
      <Wrapper>
        <Typography variant="h4" fontSize="16px" marginBottom="20">
          Would you like to send for signing the Consent Form:
        </Typography>
        <SelectField
          fullWidth
          noMargin
          name="consentFormId"
          inputProps={{ 'aria-label': 'Consent form' }}
          options={(consentForms || []).map(form => ({
            value: form.id,
            label: titleCase(form.title),
          }))}
          value={consentFormId ?? ''}
          // SelectField is a native select and hands back a string.
          onChange={value => setConsentFormId(Number(value))}
        />
      </Wrapper>
    </Modal>
  )
}

export default ConsentFormConfirmation
